<template lang="pug">
  .component-create-entity-button
    ModalReveal(:ref="componentId" :key="key" @input="closeInput")
      button.button.success(slot="trigger", v-if="cityProp") Edit
      a.fa-stack.fa-lg(slot="trigger", v-else)
        i.fa.fa-circle.fa-stack-2x
        i.fa.fa-plus.fa-stack-1x.fa-inverse
      .row
        .column
          label Name
            input(type="text", v-model="body.name")
        .column
          label Icon
            input(type="text", v-model="body.icon")
      .row
        .column
          label Color
            input(type="text", v-model="body.color")
        .column
          label Virtual
          input(type="checkbox", v-model="body.virtual")
      .row.column
        GoogleMapContainer
          GoogleMap(:apiKey="mapKey", :center="mapCenter", :searchBar="true",:mapTypeId="'roadmap'", :mapTypeControl="true", :listenForClick="true", @mapClicked="updateMarker", @placesChanged="hideMarker")
            GoogleMapMarker(v-if="markerPosition", :position="mapCenter", title="", label="")

      ActionButton(slot="footer", :action="save") Save
      button.button.alert.float-right(slot="footer", @click="$refs[componentId].close()") Cancel


</template>

<script>
import DatePicker from '../../components/structure/DatePicker'
import StartEndTimePicker from './StartEndTimePicker'
import ModalReveal from '../../components/structure/foundation/ModalReveal'
import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
import MaggieHelper from '../../maggieHelper'
import ActionButton from '../../components/structure/ui/ActionButton'
import SelectizeCommonCost from '../../components/structure/ui/lists/selectize/SelectizeCommonCost'
import GoogleMapContainer from "../../components/backoffice/GoogleMapContainer.vue";
import GoogleMap from "../../lib/map/GoogleMap.vue";
import GoogleMapMarker from "../../lib/map/GoogleMapMarker.vue"
import GoogleMapPolygon from "../../lib/map/GoogleMapPolygon.vue"
import {mapState} from "vuex";
import {EventBus} from "../../eventBus";

export default {
  name: 'CityReveal',
  components: {
    GoogleMapContainer,
    SelectizeCommonCost,
    ActionButton,
    ModalReveal,
    StartEndTimePicker,
    DatePicker,
    GoogleMap,
    GoogleMapMarker,
    GoogleMapPolygon
  },
  data() {
    return {
      body: {
        name: null,
        latitude: null,
        longitude: null,
        icon: null,
        color: null,
        virtual: false,
      },
      mapCenter: {
        lat: 0,
        lng: 0,
      },

      markerPosition: {
        lat: 0,
        lng: 0,
      },
      key: 0
    }
  },
  created() {
    if (this.cityProp !== null) {
      for (let key in this.cityProp) {
        this.body[key] = this.cityProp[key]
      }
      this.mapCenter.lat = this.body.latitude
      this.mapCenter.lng = this.body.longitude
    } else {
      this.mapCenter.lat = this.configuration.application.application_default_latitude.value
      this.mapCenter.lng = this.configuration.application.application_default_longitude.value
    }
  },
  methods: {
    save() {
      if (this.cityProp === null) {
        return KeplerBackofficeSdk.cities.make(this.body, () => {
          MaggieHelper.notification('', 'city created')
          this.key++
          EventBus.$emit('reload-list')
          this.$refs[this.componentId].close()
        })
      }

      return KeplerBackofficeSdk.cities.select(this.cityProp.id).edit(this.body, (data) => {
        MaggieHelper.notification('', 'city updated')
        EventBus.$emit('reload-list')
        this.$refs[this.componentId].close()
      })
    },
    hideMarker() {
      this.markerPosition = false
    },
    updateMarker(e) {
      this.markerPosition = true
      this.mapCenter.lat = e.lat()
      this.mapCenter.lng = e.lng()
      this.body.latitude = e.lat()
      this.body.longitude = e.lng()
    },
  },
  computed: {
    componentId() {
      return this.cityProp !== null ? `voidReveal-${this.cityProp.id}` : `voidReveal-${this._uid}`
    },
    mapKey() {
      return window.env.GOOGLE_MAPS_KEY
    },
    ...mapState({
      configuration: state => state.configuration,
    }),
  },
  props: {
    cityProp: {
      type: Object,
      default: null
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CityReveal.vue?ad309ece